import * as React from 'react';
import { AddDocumentItemOptions } from 'app/infrastructure/ui/form/types';
import { ComponentProps, ButtonSecondary } from 'ui';
import { toastFactory } from 'app/infrastructure/notifications/toast-factory';
import styles from './add-document-item-link-button.scss';

interface AddDocumentItemLinkButtonProps extends ComponentProps {
  readOnly?: boolean;
  selectAddedItem?: boolean;
  showItemAddedMessage?: boolean;
  textItemAdded?: string;
  initialValues?: { [key: string]: any };
  onAddDocumentItem?: (selectAddedItem?: boolean, options?: AddDocumentItemOptions) => void;
}

export class AddDocumentItemLinkButton extends React.PureComponent<AddDocumentItemLinkButtonProps, void> {

  private handleClick = (e?: any) => {
    const { selectAddedItem, showItemAddedMessage, textItemAdded } = this.props;
    e && e.preventDefault();

    this.props.onAddDocumentItem &&
    this.props.onAddDocumentItem(selectAddedItem, { initialValues: this.props.initialValues });

    if(showItemAddedMessage) {
      const toasts = toastFactory();
      toasts.dispatchSuccess('');
      toasts.updateSuccess(textItemAdded);
    }
  };

  public render() {
    const {
      componentId,
      className,
      label,
      readOnly
    } = this.props;

    const {
      buttonWrapper
    } = styles;

    return (
      readOnly ? null :
      <div id={componentId} className={`${buttonWrapper} ${className}`}>
        <ButtonSecondary id={`${componentId}-button`} onClick={this.handleClick}>
          {label && label.text}
        </ButtonSecondary>
      </div>
    );
  }
}
